<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="rSSuggestion.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="rSSuggestion"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="建议人" prop="proposer">
          <el-input v-model="rSSuggestion.proposer" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="建议人工号" prop="proposerNo">
          <el-input v-model="rSSuggestion.proposerNo" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="建议人部门" prop="department">
          <el-input v-model="rSSuggestion.department" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name:"RSSuggestionsEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        rSSuggestion: {
          pkid: "",
          proposer: "",
          proposerNo: "",
          department: "",
        },
        ruleValidate: {
          proposer: {required: true, message: "建议人不能为空",trigger: "blur"},
          proposerNo: {required: true, message: "建议人工号不能为空",trigger: "blur"},
          department: {required: true, message: "建议人部门不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        //console.log(row);
        this.rSSuggestion.pkid = row.pkid;
        this.dialogVisible = true;
        if(this.rSSuggestion.pkid>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `rSSuggestions/${this.rSSuggestion.pkid}`)
          .then(resp => {
            //console.log(resp);
            this.rSSuggestion = resp;
          });
      },

      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "rSSuggestions", this.rSSuggestion)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
